import {
  Mitarbeiter_ValidateMitarbeiterEmailQuery,
  Mitarbeiter_ValidateMitarbeiterEmailQueryVariables,
} from '@/gql/graphql';
import { useLazyQuery } from '@apollo/client/react';
import { useCallback } from 'react';
import { VALIDATE_MITARBEITER_EMAIL } from './graphql/queries';

export function useValidateEmail() {
  const [execute, result] = useLazyQuery<
    Mitarbeiter_ValidateMitarbeiterEmailQuery,
    Mitarbeiter_ValidateMitarbeiterEmailQueryVariables
  >(VALIDATE_MITARBEITER_EMAIL);

  const validateEmail = useCallback(
    (variables: Mitarbeiter_ValidateMitarbeiterEmailQueryVariables) =>
      execute({
        variables,
      }),
    [execute],
  );

  return [validateEmail, result] as const;
}
